import React from 'react';
import { useSelector } from 'react-redux';

const UserAssignmentHistory = ({ userHistory }) => {
  const users = useSelector((state) => state.users);

  if (!userHistory ||
      (Array.isArray(userHistory) && userHistory.length === 0) ||
      (!Array.isArray(userHistory) && Object.keys(userHistory).length === 0)) {
    return (
      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="text-4xl font-semibold mb-4">User Assignment History</h3>
        <p className="text-gray-500 italic text-center p-4 text-2xl">No assignment history available.</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 rounded-lg p-6">
      <h3 className="text-4xl font-semibold mb-4">User Assignment History</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-6 py-3 text-left text-xl font-medium text-gray-500 uppercase tracking-wider">Date/Time</th>
              <th className="px-6 py-3 text-left text-xl font-medium text-gray-500 uppercase tracking-wider">Assigned User</th>
              <th className="px-6 py-3 text-left text-xl font-medium text-gray-500 uppercase tracking-wider">Updated By</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {(Array.isArray(userHistory)
              ? userHistory.map((item, i) => [i.toString(), item]) // Convert array to [key, value] pairs
              : Object.entries(userHistory))
              .sort((a, b) => {
                // For array items, sort by index (newest first)
                if (Array.isArray(userHistory)) {
                  return parseInt(b[0]) - parseInt(a[0]);
                }
                // For object items, sort by date (newest first)
                return new Date(b[0]) - new Date(a[0]);
              })
              .map(([key, value], index) => {
                // Handle different formats:
                // 1. Old format: string (just alpha code)
                // 2. New format: object with assigner and assignee
                // 3. Array format: each item could be either format
                const isOldFormat = typeof value === 'string';
                const assignerCode = isOldFormat ? value : value.assigner;
                const assigneeCode = isOldFormat ? 'unknown' : value.assignee;

                // Find the users who made and received the assignment
                const assigningUser = Array.isArray(users)
                  ? users.find(user => user?.alpha_code === assignerCode)
                  : null;

                const assignedUser = Array.isArray(users)
                  ? users.find(user => user?.alpha_code === assigneeCode)
                  : null;

                // For array items, use index as the key
                // For object items, use the datetime string
                const displayDate = Array.isArray(userHistory)
                  ? `Entry ${parseInt(key) + 1}`
                  : new Date(key).toLocaleString();

                return (
                  <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                    <td className="px-6 py-4 whitespace-nowrap text-2xl text-gray-500">{displayDate}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-2xl text-gray-500">
                      {assignedUser
                        ? `${assigneeCode}`
                        : assigneeCode}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-2xl text-gray-500">
                      {assigningUser
                        ? `${assignerCode}`
                        : assignerCode}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserAssignmentHistory;
